<!--
 * @Description: 地图管理
 * @Author: mdb
 * @Date: 2023-05-08 10:20:06
 * @LastEditTime: 2023-05-08 15:58:05
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        :columns="columns"
        @fetch="getList"
        v-model:search="queryForm"
        ref="tableRef"
        :needPage="false"
        tableId="DcCosSystemMapManage"
      >
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'status'">
            <dc-status :enums="statusEnum" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'action'">
            <a-button type="link" v-permission="'sys_map_edit_btn'" @click="handleChange(record)">编辑</a-button>
            <a-button
              v-if="record.status === 1"
              v-permission="'sys_map_enable_btn'"
              type="link"
              @click="handleStatus(record)"
              >启用</a-button
            >
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>

  <!-- 编辑地图配置弹窗 -->
  <ModalForm ref="modalFormRef" @fetch="fetchTable" />
</template>

<script setup lang="ts">
import { reactive, ref, computed } from 'vue'
import ModalForm from './components/ModalForm.vue'
import { mapsEnum, statusEnum } from './components/enum'
import { getMapConfig, updateMapConfig } from '@/api/systemSetting/index'
import { DcMessage, DcConfirm } from '@dc-platform/dc-components'
import type { MapListItem, MapListResult } from '@/typings/api/systemSetting'

const tableRef = ref()
const queryForm = reactive({})
const tableData = ref<MapListItem[]>([])

const columns = computed(() => [
  {
    title: '地图类型',
    dataIndex: 'mapType',
    dicData: mapsEnum
  },
  { title: '状态', dataIndex: 'status' },
  { title: 'Android Key', dataIndex: 'mapAndroidKey' },
  { title: 'IOS Key', dataIndex: 'mapIosKey' },
  { title: 'Web Key', dataIndex: 'mapWebKey' },
  { title: '操作人', dataIndex: 'operatorName' },
  { title: '操作时间', dataIndex: 'operationTime', width: 190 },

  {
    title: '操作',
    dataIndex: 'action',
    width: 150,
    fixed: 'right'
  }
])

const getList = (queryForm: object, callBack: (res: MapListResult) => void) => {
  getMapConfig().then((res) => {
    tableData.value = res.data
    callBack(res)
  })
}
const fetchTable = () => tableRef.value.fetch()

const modalFormRef = ref<InstanceType<typeof ModalForm>>()
const handleChange = (rows: MapListItem) => {
  modalFormRef.value?.init(rows, tableData.value)
}
const handleStatus = (row: MapListItem) => {
  const params = tableData.value.map((item) => {
    return {
      mapType: item.mapType,
      status: item.mapType === row.mapType ? 0 : 1,
      mapAndroidKey: item.mapAndroidKey,
      mapIosKey: item.mapIosKey,
      mapWebKey: item.mapWebKey
    }
  })
  const mapName = mapsEnum.find((item) => item.value === row.mapType)?.label
  DcConfirm.warning({
    title: '操作提示！',
    content: `启用《${mapName}》地图,其它地图将自动停用,是否确认此操作？`,
    cancelText: '取消',
    okText: '继续',
    onOk() {
      updateMapConfig(params).then(() => {
        DcMessage.success('操作成功')
        fetchTable()
      })
    }
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosSystemMapManage' }
</script>

<style scoped></style>
